import React, { useCallback, useState } from 'react';
import * as Styles from './UpgradeVpsOci.styles';
import {
  Button,
  Checkbox,
  IconData,
  IconLoading,
  Input,
  Select,
} from 'gatorcomponents';
import { V2Forms } from '@/hooks/supportForms/useSupportForms.types';
import useLocale from '@/hooks/useLocale/useLocale';
import { isBRServer } from '@/utils/Validators/validation';
import { productsOptions } from './vpsOci.enum';
import { config } from '@/config';

export const UpgradeVpsOci = ({
  selectedProduct,
  opening,
  submitForm,
}) => {
  const { ticket: ticketsLocale } = useLocale();
  const { upgradeVpsOci: upgradeVpsOciLocale } = ticketsLocale.forms;
  const [serverIp, setServerIp] = useState('');
  const [newProduct, setNewProduct] = useState(null);
  const [agreedTerms, setAgreedTerms] = useState(null);
  const [agreedResponsability, setAgreedResponsability] = useState(null);

  const getCountry = () => config.COUNTRY.toLowerCase();
  const brand = getCountry();

  const checkForm = useCallback(() => {
    let isOk = false;

    isOk = isBRServer
      ? serverIp
      && newProduct
      && agreedTerms
      && agreedResponsability
      : newProduct && agreedTerms;

    return !isOk;
  }, [
    serverIp,
    newProduct,
    agreedTerms,
    agreedResponsability,
  ]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    const data = {
      locale: ticketsLocale,
      automation: false,
      pid: selectedProduct.pid,
      product: selectedProduct.id,
      subject: ticketsLocale.forms.names.upgradeVpsOci,
      key: V2Forms.UPGRADE_VPS_OCI,
      tags: ['whmcs_form_financeiro_upgrade-downgrade_plano'],
      body: isBRServer ? `
        ${upgradeVpsOciLocale.body.product(selectedProduct)}
        ${upgradeVpsOciLocale.body.request}
        ${upgradeVpsOciLocale.body.serverIp(serverIp)}
        ${upgradeVpsOciLocale.body.newProduct(newProduct)}
        ${upgradeVpsOciLocale.body.agreedTerms(agreedTerms)}
        ${upgradeVpsOciLocale.body.agreedResponsability(agreedResponsability)}
        ${upgradeVpsOciLocale.body.productId(selectedProduct)}
      ` : `
      ${upgradeVpsOciLocale.body.product(selectedProduct)}
      ${upgradeVpsOciLocale.body.request}
      ${upgradeVpsOciLocale.body.newProduct(newProduct)}
      ${upgradeVpsOciLocale.body.agreedTerms(agreedTerms)}
      ${upgradeVpsOciLocale.body.productId(selectedProduct)}
    `,
    };

    submitForm && submitForm(data);
  }, [
    ticketsLocale,
    submitForm,
    selectedProduct,
    upgradeVpsOciLocale,
    serverIp,
    newProduct,
    agreedResponsability,
    agreedTerms,
  ]);

  return (
    <Styles.Form onSubmit={e => handleSubmit(e)}>
      {isBRServer && (
        <Styles.Info>
          <div>
            <IconData />
            <strong>{upgradeVpsOciLocale.infoTitle}</strong>
          </div>
          <div>
            {upgradeVpsOciLocale.infoText}
          </div>
        </Styles.Info>
      )}

      <Styles.Title>{upgradeVpsOciLocale.title}</Styles.Title>

      <Styles.InputsWrapper>
        {isBRServer && (
        <Styles.FieldWrapper>
          <Input
            testId="serverIp"
            label={serverIp ? upgradeVpsOciLocale.fields.ipLabel : ''}
            placeholder={upgradeVpsOciLocale.fields.ipLabel}
            value={serverIp}
            onChange={e => setServerIp(e.target.value)}
            rows={3}
            counter
          />
        </Styles.FieldWrapper>
        )}

        <Select
          testId="newProduct"
          placeholder={upgradeVpsOciLocale.fields.productLabel}
          label={newProduct ? upgradeVpsOciLocale.fields.productLabel : ''}
          options={productsOptions[brand]}
          value={newProduct}
          setValue={label => setNewProduct(label)}
          withScroll
        />

        <Styles.CheckboxLabel
          htmlFor="#agreedTerms"
          data-testid="agreedTerms"
          onClick={() => setAgreedTerms(!agreedTerms)}
        >
          <Checkbox checked={agreedTerms} id="checkAgreedTerms" />
          <Styles.Text>
            {upgradeVpsOciLocale.fields.agreedTermsLabel}
          </Styles.Text>
        </Styles.CheckboxLabel>

        {isBRServer && (
          <Styles.CheckboxLabel
            htmlFor="#agreedResponsability"
            data-testid="agreedResponsability"
            onClick={() => setAgreedResponsability(!agreedResponsability)}
          >
            <Checkbox checked={agreedResponsability} id="checkAgreedResponsability" />
            <Styles.Text>
              {upgradeVpsOciLocale.fields.agreedResponsabilityLabel}
            </Styles.Text>
          </Styles.CheckboxLabel>
        )}
      </Styles.InputsWrapper>

      <Styles.ButtonWrapper>
        <Button
          size="large"
          label={opening ? <IconLoading /> : upgradeVpsOciLocale.sendButtonLabel}
          disabled={checkForm() || opening}
          type="submit"
          testId="submit"
        />
      </Styles.ButtonWrapper>
    </Styles.Form>
  );
};

export default UpgradeVpsOci;
